import React, { useState } from 'react';
import {
   color,
   space
} from "@core-ds/primitives";
import styled from 'styled-components';
import constants from '../../Shared/core-components/constants';
import { Guide } from "./featured_guides_types"

const MID_DESKTOP = '@media only screen and (max-width: 1000px)';

const {
   typography,
} = constants;

interface GuideLinkProps {
   guide: Guide,
   active: boolean,
   onClick: () => void,
}

const GuideLinkAnchor = styled.a`
   cursor: pointer;
   color: ${color.gray5};
   ${typography.paragraph}
   padding: ${space[3]} 0 ${space[3]} ${space[6]};
   border-left: 1px solid ${color.gray2};
   display: block;
`;

const GuideLinkAnchorActive = styled(GuideLinkAnchor)`
   color: ${color.black};
   border-color: ${color.blue};
`;

function GuideLink(props: GuideLinkProps) {
   const Link = props.active ? GuideLinkAnchorActive : GuideLinkAnchor;
   const guide: Guide = props.guide;
   return (
      <Link onClick={props.onClick}>
         {guide.title}
      </Link>
   );
}

export default GuideLink;
